import AutomationCommon from "../common";
const vt = AutomationCommon.vt;
const contexts = AutomationCommon.contexts;
const ga = AutomationCommon.ga;

function generateWebhookAttributesRecursive(prefix, obj) {
    if (Array.isArray(obj)) {
        var firstValid = obj.find(function (item) { return item !== null && typeof item === "object"; });
        var subAttrs = firstValid ? generateWebhookAttributesRecursive(`${prefix}.$..`, firstValid) : undefined;
        return [
            ga(contexts.WEBHOOK, `${prefix}.$..*`, "*", vt.ARRAY_OBJECT, undefined, undefined),
            ...(subAttrs || [])
        ];
    }
    if (obj && typeof obj === "object") {
        var attrs = Object.keys(obj).map(function (key) {
            var value = obj[key];
            var valueType = vt.STRING;
            if (typeof value === "number") valueType = vt.NUMBER;
            else if (typeof value === "boolean") valueType = vt.BOOLEAN;
            else if (Array.isArray(value)) valueType = vt.ARRAY_OBJECT;
            else if (typeof value === "object" && value !== null) valueType = vt.OBJECT;
            var subAttrs = (typeof value === "object" && value !== null)
                ? generateWebhookAttributesRecursive(`${prefix}.${key}`, value)
                : undefined;
            return ga(contexts.WEBHOOK, `${prefix}.${key}`, key, valueType, undefined, subAttrs);
        });
        return [
            ga(contexts.WEBHOOK, `${prefix}.$..*`, "*", vt.OBJECT, undefined, undefined),
            ...attrs
        ];
    }
    return [];
}

export default generateWebhookAttributesRecursive; 